import React from 'react';

import {useQuery} from '@apollo/react-hooks';

import type {
    SmsEditionEngagementStatsFragment,
    GetSmsBroadcastsVariables as GetSmsBroadcastsQueryVariables,
    GetSmsBroadcastEngagementStats,
} from 'nutshell-graphql-types';

import GET_BROADCAST_ENGAGEMENT_STATS from '../queries/get-sms-broadcast-engagement-stats.graphql';

export type EngagementStatsMap = Map<string, SmsEditionEngagementStatsFragment>;

export const useGetSmsBroadcastEngagementStats = (
    variables: GetSmsBroadcastsQueryVariables
): {
    engagementStatsMap: EngagementStatsMap;
    isLoadingEngagementStats: boolean;
} => {
    const {data, loading} = useQuery<
        GetSmsBroadcastEngagementStats,
        GetSmsBroadcastsQueryVariables
    >(GET_BROADCAST_ENGAGEMENT_STATS, {
        variables: variables,
        fetchPolicy: 'cache-and-network',
    });

    const smsBroadcasts = data?.smsBroadcasts;
    const engagementStatsMap: EngagementStatsMap = React.useMemo(() => {
        return new Map(
            smsBroadcasts?.map((broadcast) => [broadcast.id, broadcast.edition.engagementStats])
        );
    }, [smsBroadcasts]);

    return {
        engagementStatsMap,
        isLoadingEngagementStats: loading,
    };
};
